import { Box, Typography } from "@mui/material";

const locations = [
  {
    slug: "praha",
    name: "Praha ",
    description: "Profesionální stěhování v Praze .",
    content: (
      <>
        <Typography
          variant='body1'
          color="secondary"
          gutterBottom
          sx={{ opacity: 0.8 }}
          mb={2}
        >
          Vše co o stěhování v Praze  potřebujete vědět
        </Typography>
        <Typography variant="h3" mb={2} color="primary">
          Levné a <Box component="span" color="secondary.main">rychlé</Box> stěhování v Praze
        </Typography>
        <Typography variant="body1" paragraph gutterBottom>
          Vyklidtě sklep či přestěhujte domácnost v Praze levně. Naše služby Vám jednoduše a rychle přepraví vše co potřebujete. S námi si stěhování užijete.
        </Typography>
        <Typography variant="body1" paragraph gutterBottom>
          Nabízíme profesionální přístup, férové ceny a spolehlivost.
          Zajišťujeme stěhování bytů, domů i kanceláří, a to s maximální péčí o váš majetek. Kontaktujte nás a přesvědčte se sami.
        </Typography>
      </>
    ),
  },
  {
    slug: "praha-1",
    name: "Praha 1",
    description: "Profesionální stěhování v Praze 1.",
    content: (
      <>
        <Typography
          variant='body1'
          color="secondary"
          gutterBottom
          sx={{ opacity: 0.8 }}
          mb={2}
        >
          Vše co o stěhování v Praze 1 potřebujete vědět
        </Typography>
        <Typography variant="h3" mb={2} color="primary">
          Profesionální a <Box component="span" color="secondary.main">bezpečné</Box> stěhování v Praze 1
        </Typography>
        <Typography variant="body1" paragraph gutterBottom>
          Přestěhujte se v Praze 1 snadno a rychle. Naše služby zahrnují balení, přepravu, vykládku a montáž.
          S námi je stěhování bez starostí a vždy na míru vašim potřebám.
        </Typography>
        <Typography variant="body1" paragraph gutterBottom>
          Nabízíme profesionální přístup, férové ceny a spolehlivost.
          Zajišťujeme stěhování bytů, domů i kanceláří, a to s maximální péčí o váš majetek. Kontaktujte nás a přesvědčte se sami.
        </Typography>
      </>
    ),
  },
  {
    slug: "praha-2",
    name: "Praha 2",
    description: "Spolehlivé stěhování v Praze 2.",
    content: (<>
      <Typography
        variant='body1'
        color="secondary"
        gutterBottom
        sx={{ opacity: 0.8 }}
        mb={2}
      >
        Vše co o stěhování v Praze 2 potřebujete vědět
      </Typography>
      <Typography variant="h3" mb={2} color="primary">
        Rychlé a <Box component="span" color="secondary.main">pohodlné</Box> stěhování v Praze 2
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        Hledáte spolehlivé stěhování v Praze 2? RS Rent vám nabízí komplexní služby zahrnující balení, převoz a montáž nábytku.
        S námi zvládnete stěhování bez stresu a zbytečných komplikací.
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        Naše týmy jsou profesionálně vyškolené a připravené zvládnout i náročné stěhovací projekty.
        Zavolejte nám pro nezávaznou konzultaci a zjistěte, jak vám můžeme pomoci.
      </Typography>
    </>),
  },
  {
    slug: "praha-3",
    name: "Praha 3",
    description: "Rychlé a profesionální stěhování v Praze 3.",
    content: (<>
      <Typography
        variant='body1'
        color="secondary"
        gutterBottom
        sx={{ opacity: 0.8 }}
        mb={2}
      >
        Vše co o stěhování v Praze 3 potřebujete vědět
      </Typography>
      <Typography variant="h3" mb={2} color="primary">
        Rychlé a <Box component="span" color="secondary.main">bezstarostné</Box> stěhování v Praze 3
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        Přestěhujte se s námi v Praze 3. Naše profesionální služby vám usnadní balení, převoz i montáž.
        Nabízíme maximální spolehlivost a přátelský přístup.
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        S námi bude váš majetek vždy v bezpečí. Kontaktujte nás pro více informací o našich službách a rezervujte si termín.
      </Typography>
    </>),
  },

  {
    slug: "mlada-boleslav",
    name: "Mladá Boleslav",
    description: "Profesionální stěhování v Mladé Boleslavi.",
    content: (<>
      <Typography
        variant='body1'
        color="secondary"
        gutterBottom
        sx={{ opacity: 0.8 }}
        mb={2}
      >
        Vše co o stěhování v Mladé Boleslavi potřebujete vědět
      </Typography>
      <Typography variant="h3" mb={2} color="primary">
        Rychlé a <Box component="span" color="secondary.main">efektivní</Box> stěhování v Mladé Boleslavi
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        Nabízíme profesionální a spolehlivé stěhovací služby v Mladé Boleslavi.
        Specializujeme se na stěhování bytů, domů i kanceláří, přičemž dbáme na maximální péči o váš majetek.
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        S námi zvládnete každé stěhování bez stresu a za férovou cenu. Kontaktujte nás a přesvědčte se o našich kvalitách.
      </Typography>
    </>),
  },
  {
    slug: "jicin",
    name: "Jičín",
    description: "Rychlé a kvalitní stěhování v Jičín.",
    content: (<>
      <Typography
        variant='body1'
        color="secondary"
        gutterBottom
        sx={{ opacity: 0.8 }}
        mb={2}
      >
        Vše co o stěhování v Jičín potřebujete vědět
      </Typography>
      <Typography variant="h3" mb={2} color="primary">
        Profesionální a <Box component="span" color="secondary.main">rychlé</Box> stěhování v Jičín
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        Plánujete stěhování v Jičín? RS Rent vám zajistí hladký průběh a rychlé vyřízení všech stěhovacích úkolů.
        Naše služby zahrnují přepravu, montáž a kompletní balení.
      </Typography>
      <Typography variant="body1" paragraph gutterBottom>
        Kontaktujte nás a zjistěte, jak vám můžeme pomoci.
        Zajišťujeme bezpečnost a profesionální přístup ke každému zákazníkovi.
      </Typography>
    </>),
  },
];

export default locations;
